/* Linkerkolom van de Unified Inbox — workspace-accounts + verbonden kanalen. */
import React from "react";
import i18n from "i18next";
import { Check } from "lucide-react";
import { channelMeta } from "./constants";

export default function AccountsSidebar({ accounts, channelsConnected, selectedSet, onToggleUser, onSelectAll, onSelectNone }) {
    return (
        <aside className="border-r border-white/8 p-4 overflow-y-auto min-h-0 max-h-[240px] md:max-h-none" data-testid="inbox-accounts">
            <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm font-semibold text-white">{i18n.t("inbox.accounts_title")}</h3>
                <div className="text-[10px] flex items-center gap-2">
                    <button onClick={onSelectAll} className="text-[var(--jr-info)] hover:underline" data-testid="account-select-all">{i18n.t("inbox.select_all")}</button>
                    <button onClick={onSelectNone} className="text-[var(--jr-text-3)] hover:text-white" data-testid="account-unselect-all">{i18n.t("inbox.unselect_all")}</button>
                </div>
            </div>
            {accounts.length === 0 && (
                <p className="text-xs text-[var(--jr-text-3)] italic">{i18n.t("inbox.no_members")}</p>
            )}
            <div className="space-y-1.5">
                {accounts.map((a) => {
                    const isOn = selectedSet === null ? true : selectedSet.has(a.id);
                    const initials = (a.name || a.email || "?").split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
                    return (
                        <button key={a.id} onClick={() => onToggleUser(a.id)} data-testid={`account-${a.id}`}
                            className={`w-full flex items-center gap-3 p-2 rounded-lg border transition-colors text-left ${isOn ? "border-[var(--jr-brand)]/40 bg-[var(--jr-brand)]/[0.06]" : "border-white/8 hover:bg-white/[0.04]"}`}>
                            <div className={`w-4 h-4 rounded border-2 grid place-items-center shrink-0 ${isOn ? "border-[var(--jr-brand)] bg-[var(--jr-brand)]" : "border-white/20"}`}>
                                {isOn && <Check size={10} className="text-black" strokeWidth={3} />}
                            </div>
                            {a.avatar_url ? (
                                <img src={a.avatar_url} alt={a.name} className="w-8 h-8 rounded-full object-cover" />
                            ) : (
                                <div className="w-8 h-8 rounded-full bg-[var(--jr-surface-2)] grid place-items-center text-[10px] font-mono uppercase text-[var(--jr-text-2)]">
                                    {initials}
                                </div>
                            )}
                            <div className="flex-1 min-w-0">
                                <div className="text-sm text-white truncate">{a.name || a.email}</div>
                                {a.linkedin_handle && (
                                    <div className="text-[10px] text-[var(--jr-text-3)] truncate">{a.linkedin_handle}</div>
                                )}
                            </div>
                        </button>
                    );
                })}
            </div>

            {/* Channels-connected hint */}
            <div className="mt-4 pt-3 border-t border-white/8">
                <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-[var(--jr-text-3)] mb-2">{i18n.t("inbox.connected_channels")}</div>
                {channelsConnected.length === 0 ? (
                    <a href="/app/integrations" className="text-[11px] text-[var(--jr-amber)] hover:underline">
                        Connect Unipile →
                    </a>
                ) : (
                    <div className="flex gap-2">
                        {channelsConnected.map((ch) => {
                            const cm = channelMeta(ch);
                            const I = cm.Icon;
                            return (
                                <div key={ch} title={cm.label}
                                    className="w-7 h-7 grid place-items-center rounded-full border"
                                    style={{ background: cm.tint + "1F", color: cm.tint, borderColor: cm.tint + "55" }}>
                                    <I size={12} />
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </aside>
    );
}
